<template>
  <div class="content">
    <div class="item">
      <div class="label">编号：</div>
      <div class="value">{{ renderDetail.code }}</div>
    </div>
    <div class="item">
      <div class="label">类型：</div>
      <div class="value">
        <DataDictFinder dictType="sewageWellType" :dictValue="renderDetail.type" />
      </div>
    </div>
    <div class="item">
      <div class="label">附属物：</div>
      <div class="value">{{ renderDetail.accessary ? renderDetail.accessary : "--" }}</div>
    </div>
    <div class="item">
        <div class="label">地面标高：</div>
        <div class="value">{{ parseFloat(renderDetail.elevation).toFixed(3) }}m</div>
    </div>
    <div class="item">
        <div class="label">管内底标高：</div>
        <div class="value">{{   parseFloat(renderDetail.elevation-renderDetail.depth).toFixed(3)  }}m</div>
    </div>
    <div class="item">
        <div class="label">埋深：</div>
        <div class="value">{{ parseFloat(renderDetail.depth).toFixed(3) }}m</div>
    </div>
    <div class="item">
      <div class="label">井盖直径：</div>
      <div class="value">{{ renderDetail.diameterCover }}mm</div>
    </div>
    <div class="item">
      <div class="label">井室直径：</div>
      <div class="value">{{ renderDetail.diameterRoom }}mm</div>
    </div>

    <div class="item">
      <div class="label">所在道路：</div>
      <div class="value">{{ renderDetail.location }}</div>
    </div>

    <div class="item">
      <div class="label">井盖材质：</div>
      <div class="value">{{ renderDetail.materialCover }}</div>
    </div>

    <div class="item">
      <div class="label">检查井材质：</div>
      <div class="value">{{ renderDetail.materialWell }}</div>
    </div>

    <div class="item">
      <div class="label">井盖形状：</div>
      <div class="value">{{ renderDetail.shapeCover }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    renderDetail: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>


<style lang="less" scoped>
.content {
  padding: 0 1vw 2vh;
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 1vh;
  color: #fff;
  .item {
    display: flex;
    align-items: center;

    .label {
      width: 6em;
    }

    .value {
      color: var(--theme-color);
    }
  }
}
</style>